module.exports = __webpack_public_path__ + "137d9c9690132e7a40b25ec1a53e6c87.svg";